import { UseMutationResult, useQueryClient } from "@tanstack/react-query"
import { useCurrentUser } from "#/components/context/user/UserContext"
import { useIntl } from "react-intl"
import { carrotClient } from "#/utils/CarrotClient"
import { useToastsWithMutation } from "#/utils/hooks/useToastsWithMutation"

export function useRemovePartner(): UseMutationResult {
  const { refreshUserInfo } = useCurrentUser()
  const queryClient = useQueryClient()
  const intl = useIntl()

  const getSuccessMessage = (): string => {
    return intl.formatMessage({ defaultMessage: "Partner has been removed." })
  }

  const request = () => carrotClient.removePartner()

  return useToastsWithMutation({
    request,
    getSuccessMessage: getSuccessMessage,
    onSuccess: () => {
      refreshUserInfo()
      // Invalidate user queries to trigger form re-initialization
      queryClient.invalidateQueries({ queryKey: ["user"] })
      queryClient.invalidateQueries({ queryKey: ["currentUser"] })
    },
    retry: false
  })
}
